import popularCategory from 'vuex-store/modules/products/popular-category';

// initial state
const state = () => ({});

const getters = {};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,

  modules: {
    'popular-category': popularCategory,
  },
};
